module.exports = __webpack_public_path__ + "static/section6-9a199c188e913653c82e1e0f34a49d11.svg";